import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import { withStyles } from '@mui/styles';
import { styles } from './styles.js';

const MuiIconButton = ({ classes, onClick, label, icon, buttonProps }) => {
  if (!label) {
    return (
      <IconButton
        size="small"
        classes={{ root: classes.iconRoot }}
        {...buttonProps}
      >
        <Icon>
          <img src={icon} />
        </Icon>
      </IconButton>
    );
  }
  return (
    <Button
      size="small"
      variant="text"
      onClick={onClick}
      classes={{ root: classes.root, startIcon: classes.startIcon }}
      {...buttonProps}
      startIcon={
        <Icon>
          <img src={icon} />
        </Icon>
      }
    >
      {label}
    </Button>
  );
};

MuiIconButton.defaultProps = {
  classes: {},
  buttonProps: {},
  label: null,
};

MuiIconButton.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string,
  buttonProps: PropTypes.object,
  icon: PropTypes.string.isRequired,
};

export default withStyles(styles)(MuiIconButton);
